<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="12" lg="12" class="text-center p-2">
                        <CRow>
                            <CCol sm="6">
                                <div class="p-2 text-left">
                                    <h3 class="custom-18px-500 text-left">Evaluation Category</h3>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="p-2 text-right">
                                    <CButton class="btn-border-blue font-color-0B63F6" @click="openCategory"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Add Category</CButton>
                                </div>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <table class="table table-responsive-sm text-left">
                            <thead class="custom-table">
                                <th>Category</th>
                                <th></th>
                            </thead>
                            <tbody v-for="item in eva" v-bind:key="item.Id">
                                <tr>
                                    <td>{{ item.name }}</td>
                                    <td class="text-right"><img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" @click="DeleteCategory(item.name)"/></td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
    
                </CRow>
            </CCard>
    
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="12" lg="12" class="text-center p-2">
                        <CRow>
                            <CCol sm="6">
                                <div class="p-2 text-left">
                                    <h3 class="custom-18px-500 text-left">Evaluation Form</h3>
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="p-2 text-right">
                                    <CButton class="btn-border-blue font-color-0B63F6" @click="openForm"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Form</CButton>
                                </div>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <table class="table table-responsive-sm text-left" v-if="Array.isArray(filteredevaluationTableData) && filteredevaluationTableData.length > 0">
                            <thead class="custom-table">
                                <th></th>
                                <th></th>
                            </thead>
                            <tbody v-for="item in evaform" v-bind:key="item.Id">
                                <tr>
                                    <td>{{ item.title }}
                                    <br />
                                {{ item.description }}</td>
                                    <td class="text-right"><img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" @click="DeleteCategoryForm(item.title,item.name)"/></td>
                                </tr>
                                
                            </tbody>
                        </table>
                        <div v-else class="no-data-message">
    
                            <div class="full-height-container">
                                <div class="no-data-message">
                                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                </div>
                            </div>
    
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
        </CCol>
        <div v-if="OpenAddCategory" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left font-inter">Add Category</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddCategory" /></CCol>
                </CRow>
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Category</h3>
                                <CInput type="text" v-model="Name"/>
                            </CCol>
    
    
                        </CRow>
                        <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half mt-3" block @click="UpdateCategory">
                            Submit</CButton>
    
                    </div>
                </CCol>
            </div>
        </div>

        <div v-if="OpenAddForm" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left font-inter">Create Form</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddForm" /></CCol>
                </CRow>
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Form Title</h3>
                                <CInput type="text" v-model="FormName"/>
                            </CCol>

                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Form Description</h3>
                                <CInput type="text" v-model="FormDescription"/>
                            </CCol>

                            <CCol sm="12" class="mt-2 mb-2">
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/evaluate.png" width="30px"/>
                                    </CCol>
                                    <CCol sm="9">Enable Calculation</CCol>
                                    <CCol sm="2"> 
                                        <CSwitch color="primary" class="mx-1 custom-border-purple mt-1" name="switch1" :checked="IsCalculate" shape="pill" />
                                    </CCol>
                                </CRow>
                            </CCol>
    
    
                        </CRow>
                        <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half mt-3" block @click="UpdateCategoryForm">
                            Submit</CButton>
    
                    </div>
                </CCol>
            </div>
        </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>

        
    </div>
</template>




<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {

            OpenAddCategory: false,
            OpenAddForm: false,
            Name: "",
            isPopupSuccess: false,
            eva: [],

            FormName: "",
            FormDescription: "",
            IsCalculate: false,

            filteredevaluationTableData: [],
            evaform: [],



        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListEvaluation();
                await this.GetListEvaluationForm();

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        openCategory() {
            this.OpenAddCategory = true;
        },

        closePopupAddCategory() {
            this.OpenAddCategory = false;
        },
        openForm() {
            this.OpenAddForm = true;
        },

        closePopupAddForm() {
            this.OpenAddForm = false;
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        },
        UpdateCategory: function() {
            const formData = new FormData();

            formData.append("Name", this.Name);
            formData.append("Status", true);

            return this.$API
                .post(this.$InsertEvaluationSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.OpenAddForm = false;
                        this.GetListEvaluation();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        DeleteCategory: function(name) {
            const formData = new FormData();

            formData.append("Name", name);
            formData.append("Status", false);

            return this.$API
                .post(this.$InsertEvaluationSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.OpenAddForm = false;
                        this.GetListEvaluation();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async GetListEvaluation() {
            try {
                const response = await this.$API.get(this.$GetListCompanySettingEvaluation, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.eva = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        },
        UpdateCategoryForm: function() {
            const formData = new FormData();

            formData.append("Title", this.FormName);
            formData.append("Description", this.FormDescription);
            formData.append("IsCalculate", this.IsCalculate);
            formData.append("Status", true);

            return this.$API
                .post(this.$InsertEvaluationFormSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.OpenAddForm = false;
                        this.GetListEvaluationForm();
                        this.FormName ="";
                        this.FormDescription = "";
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        DeleteCategoryForm: function(title,description) {
            const formData = new FormData();

            formData.append("Title", title);
            formData.append("Description", description);
            //formData.append("IsCalculate", isCalculate);
            formData.append("Status", false);

            return this.$API
                .post(this.$InsertEvaluationFormSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.OpenAddForm = false;
                        this.GetListEvaluationForm();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async GetListEvaluationForm() {
            try {
                const response = await this.$API.get(this.$GetListCompanySettingEvaluationForm, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.evaform = response.data;
                    this.filteredevaluationTableData = this.evaform;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },



    }

};
</script>